import { useMutation, useQueryClient } from '@tanstack/react-query';
import { connectService } from 'v2/services/connect';

export const useCreateConnect = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (connect: any) => connectService.createConnect(connect),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['connect', 'myConnects'] });
    }
  });
};
